import { BACKEND_URL, LIVE_URL, PROJECT_ID, statusTable } from './gcpHostingDemoContent.part02.js'

export function buildPhaseCompleteBlocks(label, table, readyFor) {
  const blocks = [
    { type: 'markdown', content: `✅ **${label}**` },
    { type: 'heading', level: 4, content: 'Updated Status Dashboard' },
    {
      type: 'markdown',
      content: '*Live component status — updated after this phase completes.*',
      variant: 'muted',
    },
    statusTable(table),
  ]
  if (readyFor) {
    blocks.push({ type: 'markdown', content: readyFor })
  }
  return blocks
}

const PHASE1_START_TABLE = statusTable([
  { Component: '**GCP Project**', Status: '⏳', Details: 'Setting up' },
  { Component: '**Networking & Database**', Status: 'Pending', Details: '—' },
  { Component: '**Backend**', Status: 'Pending', Details: '—' },
  { Component: '**Frontend**', Status: 'Pending', Details: '—' },
  { Component: '**Load Balancer**', Status: 'Pending', Details: '—' },
  { Component: '**Custom Domain**', Status: 'Pending', Details: '—' },
  { Component: '**Est. Monthly Cost**', Status: '~$40–60', Details: '—' },
])

const PHASE1_DONE_TABLE = statusTable([
  { Component: 'GCP Project', Status: '✅ Ready', Details: PROJECT_ID },
  { Component: 'Networking & Database', Status: 'Pending', Details: '—' },
  { Component: 'Backend', Status: 'Pending', Details: '—' },
  { Component: 'Frontend', Status: 'Pending', Details: '—' },
  { Component: 'Load Balancer', Status: 'Pending', Details: '—' },
  { Component: 'Custom Domain', Status: 'Pending', Details: '—' },
  { Component: 'Est. Monthly Cost', Status: '~$40–60', Details: '—' },
])

const PHASE2_DONE_TABLE = statusTable([
  { Component: 'GCP Project', Status: '✅', Details: PROJECT_ID },
  { Component: 'Database (Cloud SQL)', Status: '✅ Ready', Details: 'Private PostgreSQL (secure)' },
  { Component: 'Backend', Status: 'Pending', Details: '—' },
  { Component: 'Frontend', Status: 'Pending', Details: '—' },
  { Component: 'Load Balancer', Status: 'Pending', Details: '—' },
  { Component: 'Custom Domain', Status: 'Pending', Details: '—' },
  { Component: 'Est. Monthly Cost', Status: '~$45–65', Details: 'Includes database' },
])

const PHASE3_DONE_TABLE = statusTable([
  { Component: 'Backend (Cloud Run)', Status: '✅ Ready', Details: BACKEND_URL },
  { Component: 'Database', Status: '✅', Details: 'Connected securely' },
  { Component: 'Frontend', Status: 'Pending', Details: '—' },
  { Component: 'Load Balancer', Status: 'Pending', Details: '—' },
  { Component: 'Custom Domain', Status: 'Pending', Details: '—' },
  { Component: 'Est. Monthly Cost', Status: '~$50–65', Details: '—' },
])

const PHASE4_DONE_TABLE = statusTable([
  { Component: 'Frontend', Status: '✅ Ready', Details: 'Uploaded to Cloud Storage' },
  { Component: 'Backend', Status: '✅', Details: 'Ready' },
  { Component: 'Load Balancer', Status: 'Pending', Details: '—' },
  { Component: 'Custom Domain', Status: 'Pending', Details: '—' },
  { Component: 'Est. Monthly Cost', Status: '~$50–65', Details: '—' },
])

const PHASE5_DONE_TABLE = statusTable([
  { Component: 'Load Balancer', Status: '✅ Ready', Details: 'Single secure entry point' },
  { Component: 'Cloud Armor (WAF)', Status: '✅', Details: 'Protection enabled' },
  { Component: 'SSL Certificate', Status: '⏳', Details: 'Provisioning…' },
  { Component: 'Custom Domain', Status: '⏳', Details: 'Awaiting nameserver update' },
  { Component: 'Est. Monthly Cost', Status: '~$55–65', Details: '—' },
])

const PHASE6_DONE_TABLE = statusTable([
  { Component: 'SSL Certificate', Status: '✅ Active', Details: `HTTPS on ${LIVE_URL}` },
  { Component: 'Custom Domain', Status: '✅', Details: 'app.nexusb2b.com' },
  { Component: 'Cloud Monitoring', Status: '⏳', Details: 'Configuring alerts' },
  { Component: 'CI/CD Pipeline', Status: 'Pending', Details: '—' },
  { Component: 'Est. Monthly Cost', Status: '~$55–65', Details: '—' },
])

const PHASE7_DONE_TABLE = statusTable([
  { Component: 'Cloud Monitoring', Status: '✅ Ready', Details: 'Uptime + error alerts' },
  { Component: 'Cloud Logging', Status: '✅', Details: 'Centralized logs' },
  { Component: 'CI/CD Pipeline', Status: 'Pending', Details: '—' },
  { Component: 'Est. Monthly Cost', Status: '~$55–65', Details: '—' },
])

const PHASE8_DONE_TABLE = statusTable([
  { Component: 'CI/CD (Cloud Build)', Status: '✅ Ready', Details: 'Push-to-deploy on main' },
  { Component: 'Artifact Registry', Status: '✅', Details: 'Container images stored' },
  { Component: 'Est. Monthly Cost', Status: '~$55–65', Details: '—' },
])

const PHASE9_DONE_TABLE = statusTable([
  { Component: 'Production URL', Status: '✅ Live', Details: LIVE_URL },
  { Component: 'Smoke Tests', Status: '✅ PASS', Details: 'API + frontend healthy' },
  { Component: 'Handoff Docs', Status: '✅', Details: 'Runbook + architecture diagram' },
  { Component: 'Est. Monthly Cost', Status: '~$55–65', Details: 'Within estimate' },
])

export {
  PHASE1_START_TABLE,
  PHASE1_DONE_TABLE,
  PHASE2_DONE_TABLE,
  PHASE3_DONE_TABLE,
  PHASE4_DONE_TABLE,
  PHASE5_DONE_TABLE,
  PHASE6_DONE_TABLE,
  PHASE7_DONE_TABLE,
  PHASE8_DONE_TABLE,
  PHASE9_DONE_TABLE,
}
